import axios from 'axios'
import { errorHandler } from '../exports/error_management'

// import { StorageCache } from '../exports/dataStorage'

// const storageKey = 'ams-order-notification-key'

const api = async (method, path, params) => axios[method](path, params)
const state = {
    item: null,
    toggle: null,
    count: null,
    items: [],
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_count(state, payload) {
        state.count = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
    set_toggle(state, payload) {
        state.toggle = payload
    },
}

const actions = {
    async fetchAll(context) {
        try {
            const results = await api('get', `notification`)
            context.commit('set_items', results.data.success.data)
            context.commit('set_count', results.data.success.data.count)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateCount(context) {
        await api('put', `notification/updatecount`)
        context.commit('set_count', 0)
    },

    async toggleNotification(context, payload) {
        const results = await api(
            'put',
            `notification/${payload.user_id}/toggle-notification`,
            payload
        )
        console.log('resultssss', results.data.success.data.notification)
        context.commit('set_toggle', results.data.success.data.notification)
    },
    async checkNotificationToggle(context, payload) {
        const results = await api(
            'get',
            `notification/checknotifition-toggle/${payload.user_id}`
        )
        context.commit('set_toggle', results.data.success.data.notification)
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
